module.exports = __webpack_public_path__ + "static/media/bowl-veggies.416bf947.jpeg";